import { atom } from 'jotai';

import type { AdjustmentVersion } from '@/react-query/useGetSharpenedImages';

export type AdjustmentType = 'HD1' | 'HD2' | 'Pano';
export const selectedAdjustmentTypeAtom = atom<AdjustmentType>('HD1');
export const selectedVisitAtom = atom<number | undefined>(undefined);
export const selectedPatientIdAtom = atom<string | undefined>(undefined);
export const selectedImageIdAtom = atom<string | undefined>(undefined);
export const leftFilterAtom = atom<AdjustmentVersion | null>(null);
export const finalFilterAtom = atom<AdjustmentVersion | null>(null);
